import { NgModule } from '@angular/core';

import { FlickityDirective } from './components/flickity/flickity.directive';
import { FlickityChildDirective } from './components/flickity-child/flickity-child.directive';
import { AppConfigService } from './services/app-config.service';

const DIRECTIVES = [FlickityDirective, FlickityChildDirective];


export class FlickityModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: DIRECTIVES,
    exports: DIRECTIVES,
    providers: [AppConfigService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
